<template>
    <div
        :class="{
            'sm:border-t sm:border-gray-200 sm:py-5' : withBorder,
            'space-y-1 sm:space-y-0 sm:grid sm:grid-cols-3 sm:gap-4 items-center': isInline
        }"
    >
        <p v-if="label"
               :class="{
                   'block text-sm text-gray-900 font-bold': true,
                   'mb-2': !isInline,
                   'sm:mt-px sm:col-span-2': isInline
                }"
        >
            {{ label }} {{ required ? '*' : '' }}
        </p>

        <div :class="isInline ? 'sm:col-span-1' : 'w-full'" class="flex flex-col relative">
            <label type="button" :for="id" aria-pressed="false" :class="(mutableValue ? 'bg-indigo-600' : 'bg-gray-200') + ' relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'">
                <span class="sr-only">{{ label }}</span>
                <span aria-hidden="true" :class="(mutableValue ? 'translate-x-5' : 'translate-x-0') + ' inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'"></span>
            </label>

            <input
                type="checkbox"
                :id="id"
                :name="name"
                v-model="mutableValue"
                class="hidden"
                :disabled="disabled"
                @change="handleChange"
            >

            <div v-if="tooltip || errors && errors.length > 0" class="flex flex-col justify-between mt-2">
                <p v-if="errors && errors.length > 0" v-for="error in errors" class="text-red-500 text-xs italic mb-0 mt-1">{{ error }}</p>
                <p v-if="tooltip" class="text-xs italic text-gray-800">tooltip</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                mutableValue: typeof this.modelValue === 'string' ? !!Number(this.modelValue) : this.modelValue
            }
        },
        props: {
            modelValue: [Boolean, String],
            name: String,
            label: String,
            errors: Array,
            id: String,
            tooltip: String,
            disabled: Boolean,
            required: Boolean,
            isInline: Boolean,
            withBorder: Boolean,
        },
        methods: {
            handleChange() {
                this.$emit('update:modelValue', !!this.mutableValue);
            },
        }
    }
</script>
